import script from "./MobileCategories.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileCategories.vue?vue&type=script&setup=true&lang=js"

import "./MobileCategories.vue?vue&type=style&index=0&id=4a3eac16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a3eac16"]])

export default __exports__